var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"className":"layout"}},[_c('sidebar',{staticClass:"sidebar-container"}),_c('div',{attrs:{"className":"bg-box"}}),_c('div',{attrs:{"className":"nav-container"}},[_c('nav-bar')],1),_c('div',{staticClass:"pt50",attrs:{"className":"main-container"}},[_c('app-bar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }